module.exports = __webpack_public_path__ + "1c9f990b2c32408e3a021307279b5c54.svg";